import script from "./ind.vue?vue&type=script&setup=true&lang=js"
export * from "./ind.vue?vue&type=script&setup=true&lang=js"

import "./ind.vue?vue&type=style&index=0&id=ef9d4184&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef9d4184"]])

export default __exports__